import React from 'react';
import { SvgIcon } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

const BoxIcon = ({ width = 100, height = 100, ...rest }: SvgIconProps) => {
  return (
    <SvgIcon
      sx={{ width, height }}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="50" cy="50.5" r="50" fill="#F6F7F8" />

      <path
        d="M65 37.1665H35V43.8332H65V37.1665Z"
        stroke="#727F93"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />

      <path
        d="M38.3333 43.8335V63.8335H61.6666V43.8335"
        stroke="#727F93"
        strokeWidth="1.5"
        strokeLinecap="square"
        fill="none"
      />

      <path
        d="M46.6667 50.5H53.3334"
        stroke="#727F93"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default BoxIcon;
